import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class DutiesEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: null,
      logbook_external_id: null,
      name: null,
      abbreviation: null,
      anac_code: null,
      role: null,
      instructor: false,
      copilot_as_captain: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    this.setState({instructor: false, copilot_as_captain: false});
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/funcao/bordo/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/funcoes/bordo');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.id,
            logbook_external_id: responseJson.data.logbook_external_id,
            name: responseJson.data.name,
            abbreviation: responseJson.data.abbreviation,
            anac_code: responseJson.data.anac_code,
            role: responseJson.data.role,
            instructor: responseJson.data.instructor,
            copilot_as_captain: responseJson.data.copilot_as_captain,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      logbook_external_id: this.state.logbook_external_id,
      name: this.state.name,
      abbreviation: this.state.abbreviation,
      anac_code: this.state.anac_code,
      instructor: this.state.instructor,
      copilot_as_captain: this.state.copilot_as_captain,
      role: this.state.role,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcao/bordo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.FuncoesDeBordo.EditarFuncaoDeBordo.titulo}</h3>
      <Link to="/funcoes/bordo" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.FuncoesDeBordo.EditarFuncaoDeBordo.formulario.Nome}</label>
              <input type="text" name="name" className="form-control" placeholder="" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.FuncoesDeBordo.EditarFuncaoDeBordo.formulario.Abreviacao}:</label>
              <input type="text" name="abbreviation" className="form-control" placeholder="" value={this.state.abbreviation} onChange={this.handleChange.bind(this, 'abbreviation')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.FuncoesDeBordo.EditarFuncaoDeBordo.formulario.CodigoANAC}:</label>
              <Select
                className="form-field-name"
                name="anac_code"
                value={this.state.anac_code}
                searchable={true}
                placeholder={this.locale.FuncoesDeBordo.EditarFuncaoDeBordo.formulario.placeholder.SelecioneCodigoANAC}
                onChange={this.handleSelectChange.bind(this, 'anac_code')}
                options={[
                  { value: "P1", label: "P1" },
                  { value: "I P2", label: "I P2" },
                  { value: "I1", label: "I1" },
                  { value: "I2", label: "I2" },
                  { value: "O1", label: "O1" },
                  { value: "O2", label: "O2" },
                  { value: "O3", label: "O3" },
                  { value: "V1", label: "V1" },
                  { value: "V2", label: "V2" },
                  { value: "V3", label: "V3" },
                  { value: "C", label: "C" },
                  { value: "M", label: "M" },
                  { value: "X", label: "X" },
                  { value: "D", label: "D" },
                ]}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.FuncoesDeBordo.EditarFuncaoDeBordo.formulario.Funcao}:</label>
              <Select
                className="form-field-name"
                name="role"
                value={this.state.role}
                searchable={true}
                placeholder={this.locale.FuncoesDeBordo.EditarFuncaoDeBordo.formulario.placeholder.SelecioneFuncao}
                onChange={this.handleSelectChange.bind(this, 'role')}
                options={[
                  {value: "captain", label: this.locale.FuncoesDeBordo.EditarFuncaoDeBordo.formulario.opcoesFuncao.CMDT},
                  {value: "copilot", label: this.locale.FuncoesDeBordo.EditarFuncaoDeBordo.formulario.opcoesFuncao.COPIL},
                  {value: "flight_attendant", label: this.locale.FuncoesDeBordo.EditarFuncaoDeBordo.formulario.opcoesFuncao.CMS},
                ]}
              />
            </div>
          </div>
        </div>
          {
            (this.state.role === 'captain') ?
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>{this.locale.FuncoesDeBordo.EditarFuncaoDeBordo.formulario.Instrutor}?</label>
                  <br/>
                  <Toggle
                    checked={this.state.instructor}
                    aria-label=''
                    name="instructor"
                    onChange={this.handleToggleChange.bind(this, 'instructor')} />
                </div>
              </div>
              <div className="col-md-9">
                <div className="form-group">
                  <label>{this.locale.FuncoesDeBordo.EditarFuncaoDeBordo.formulario.PermiteCopilotoRealizarHorasEmComandoDesdePossuaAutorizacao}?</label>
                  <br/>
                  <Toggle
                    checked={this.state.copilot_as_captain}
                    aria-label=''
                    name="copilot_as_captain"
                    onChange={this.handleToggleChange.bind(this, 'copilot_as_captain')} />
                </div>
              </div>
            </div>
             : ''
          }
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>LogbookApp ID:</label>
              <input type="text" className="form-control" name="logbook_external_id" value={this.state.logbook_external_id} onChange={this.handleChange.bind(this, 'logbook_external_id')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.editar}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default DutiesEdit;



// WEBPACK FOOTER //
// ./src/Components/Duties/DutiesEdit.js